import {
  actionCreator,
  checkHttpStatus,
  DELETE_SECURITY_QUESTION,
  GET_SECURITY_QUESTION,
  GET_SECURITY_QUESTION_BY_ID,
  jsonApiHeader,
  POST_SECURITY_QUESTION,
  securityQuestionActionTypes,
  showErrorMessage,
  showSuccessMessage,
} from '../constants/ApiConstants';
import { checkHttpStatusAuthCheck, createSearchUrlForCustomAPI } from '../../../../../actions/utilAction';

export const getSecurityQuestion = (searchObj) => {

  return (dispatch, getState) => {
    dispatch(actionCreator(securityQuestionActionTypes.get_security_question.REQUEST));

    let query_params = createSearchUrlForCustomAPI(searchObj);;
    fetch(`${GET_SECURITY_QUESTION}${query_params}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
    .then((res)=>checkHttpStatusAuthCheck(res,dispatch,getState))
      .then(function(response) {
        dispatch(actionCreator(securityQuestionActionTypes.get_security_question.SUCCESS, response));
      })
      .catch(function(error) {
        // errorHandler(error);
      });
  };
};

export const saveSecurityQuestion = (formData) => {
  let postData = JSON.stringify(formData);
  return (dispatch, getState) => {
    dispatch(actionCreator(securityQuestionActionTypes.post_security_question.REQUEST));
    fetch(`${POST_SECURITY_QUESTION}`, {
      method: 'POST',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      body: postData,
    })
      .then(checkHttpStatus)
      .then(function(response) {
        // console.log(response);
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(securityQuestionActionTypes.post_security_question.SUCCESS, response));
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(securityQuestionActionTypes.post_security_question.FAILURE));
        }
      });
  };
};

export const deleteSecurityQuestion = (id) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(securityQuestionActionTypes.delete_security_question.REQUEST));

    fetch(`${DELETE_SECURITY_QUESTION}?questionId=${id}`, {
      method: 'PATCH',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then((response) => {
        // console.log('response.....',response)
        if (response.statusCode === 200) {
          showSuccessMessage(response.message);         
        } else {
          showErrorMessage(response.message);
        }
        dispatch(actionCreator(securityQuestionActionTypes.delete_security_question.SUCCESS, response));
      }).catch(function(error) {
        // console.log(error);
      });
  };
};
export const getSecurityQuestionById = (securityQuestionId) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(securityQuestionActionTypes.get_security_question_by_id.REQUEST));

    fetch(`${GET_SECURITY_QUESTION_BY_ID}/${securityQuestionId}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
    .then((res)=>checkHttpStatusAuthCheck(res,dispatch,getState))
      .then(function(response) {
        // console.log('response: ', response);
        dispatch(actionCreator(securityQuestionActionTypes.get_security_question_by_id.SUCCESS, response));
      })
      .catch(function(error) {
        console.log('error --', error);
      });
  };
};



// WEBPACK FOOTER //
// ./src/modules/Masters/components/securityQuestions/actions/SecurityQuestionActions.js